import { graphql } from 'react-relay';

/**
 * Slice-3 experiments read: every defined experiment with its weighted variants
 * and the vault cohort frozen into it, plus the flag catalogue so the define
 * form can offer a flag to decorate. Lives in `relay/` (not a screen) so the
 * `graphql` tag stays confined to Babel-transformed data modules — screens stay
 * transform-free and unit-testable.
 *
 * `firstExposedUtc` is fetched but is always null today: pv-data has no consumer
 * for exposure events yet, so nothing marks an assignment as exposed. The screen
 * surfaces that as the "measurement pending" indicator.
 */
export const experimentsScreenQuery = graphql`
    query experimentsQuery {
        experiments {
            key
            flagKey
            variants {
                name
                weight
            }
            assignments {
                vaultId
                variant
                assignedUtc
                firstExposedUtc
            }
        }
        featureFlags {
            key
            kind
        }
    }
`;
